import { render, staticRenderFns } from "./Crisis_statistics.vue?vue&type=template&id=148f8ebc"
import script from "./Crisis_statistics.vue?vue&type=script&lang=js"
export * from "./Crisis_statistics.vue?vue&type=script&lang=js"
import style0 from "./Crisis_statistics.vue?vue&type=style&index=0&id=148f8ebc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports